import { produce } from "immer";
import * as policieActions from "store/actions/policieActions";

const initialState = {
  data: [],
  unconfirmed: [],
  ids: [],
  open: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case policieActions.SET_POLICIE_DATA: {
      draft.data = action.payload;
      break;
    }

    case policieActions.SET_UNCONFIRMED_POLICIE_DATA: {
      draft.unconfirmed = action.payload;
      break;
    }

    case policieActions.SET_POLICIE_OPEN: {
      draft.ids = action.payload;
      draft.open = !!action.payload.length;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
